// extracted by mini-css-extract-plugin
export var arrow = "_3e-6";
export var changeItem = "_3e-3";
export var changesHeader = "_3e-1";
export var changesList = "_3e-2";
export var container = "_3e-0";
export var pathLabel = "_3e-4";
export var value = "_3e-7";
export var valuesContainer = "_3e-5";